import { render } from "./address.vue?vue&type=template&id=27c8233e&scoped=true"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"

import "./address.vue?vue&type=style&index=0&id=27c8233e&scoped=true&lang=css"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c8233e"]])

export default __exports__